export default __webpack_public_path__ + "static/media/history.cf75e99b.svg";